import { render, staticRenderFns } from "./BookingAccommodationDisplay.vue?vue&type=template&id=f10112a0&scoped=true&"
import script from "./BookingAccommodationDisplay.vue?vue&type=script&lang=ts&"
export * from "./BookingAccommodationDisplay.vue?vue&type=script&lang=ts&"
import style0 from "./BookingAccommodationDisplay.vue?vue&type=style&index=0&id=f10112a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f10112a0",
  null
  
)

export default component.exports